// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: `${API_BASE_URL}/api/auth/login`,
  REGISTER: `${API_BASE_URL}/api/auth/register`,
  LOGOUT: `${API_BASE_URL}/api/auth/logout`,
  REFRESH_TOKEN: `${API_BASE_URL}/api/auth/refresh`,
  ME: `${API_BASE_URL}/api/auth/me`,
  CHANGE_PASSWORD: `${API_BASE_URL}/api/auth/change-password`,

  // Service Catalog endpoints
  SERVICE_CATALOG: `${API_BASE_URL}/api/ServiceCatalog`,

  // Scraper endpoints
  SCRAPER: `${API_BASE_URL}/api/scraper`,
};

export default API_BASE_URL;
